export default {"src":"/vendor/_next/static/media/logo_white.53e44d15.svg","height":36,"width":126,"blurWidth":0,"blurHeight":0};